<template>
  <div class="main_center" >
    <div class="content" style="min-height:calc(100vh - 80px - 234px)"  v-loading="dataListLoading">

      <!-- <el-row :gutter="15" :style="{'min-height':tableMaxHeight}" v-loading="dataListLoading">
        <el-col :span="6" v-for="item in tableData" :key="item.id">
          <el-card class="projectCard">
            <div slot="header" class="clearfix">
              <span class="title" :title="item.bidSectionName">{{item.bidSectionName}}</span>
              <p class="deleteBtn" v-if="deleteBtnShow">
                <i :style="{'color':hasSelect(item.id)?'#5cb6ff':'#c0c4cc'}"  @click="triggerSelectItem(item.id)" :class="hasSelect(item.id)?'el-icon-circle-check':'el-icon-circle-close'"></i>
              </p>
              <el-dropdown style="float: right;right: -16px;top: -22px;" v-if="hasBtnPermission('btn_jz_witnessHis_'+businessType+'_show')"  @command="handleCommand">
                <span class="el-dropdown-link" style="cursor: pointer">
                  <icon-svg name="more" class="site-sidebar__menu-icon"></icon-svg>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="composeValue(0,item)">{{businessType|typeMapperProjectAngle}}</el-dropdown-item>
                  <el-dropdown-item :command="composeValue(1,item)">{{businessType|typeMapperBidAngle}}</el-dropdown-item>
                  <el-dropdown-item :command="composeValue(2,item)">招标代理视角</el-dropdown-item>
                  <el-dropdown-item :command="composeValue(3,item)">投标人视角</el-dropdown-item>
                  <el-dropdown-item :command="composeValue(4,item)">评委视角</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <p class="ellipsis"><span>{{businessType|typeMapperBidCodeDesc}}</span><span :title="item.bidSectionCode">{{item.bidSectionCode}}</span></p>
            </div>
            <p class="info"><span>{{businessType|typeMapperBidAngle}}：</span><span :title="item.tendererName">{{item.tendererName}}</span></p>
            <p class="info"><span>招标代理：</span><span :title="item.tenderAgencyName">{{item.tenderAgencyName}}</span></p>
            <p class="info"><span>登记时间：</span><span>{{formatDate(item.createTime,'yyyy-MM-dd HH:mm')}}</span></p>
          </el-card>
        </el-col>

        <emptyInfo v-if="tableData.length == 0" :emptyMsg="'暂无记录'" ></emptyInfo>

      </el-row> -->
     <div v-if="tableData.length>0">
		<projectCom v-for="(item,i) in tableData" :data="item" :isShowTag="true" :hasViewBtnPer="hasBtnPermission('supperviseion_businessWitnessHis_detail_btn')" :key="i" :keyCopy="i" :systemType="businessType" class="project_par" ></projectCom>
           <pagination
                class="limit"
                style="margin-top: 6px"
                :page-sizes="[pageSize, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
            </pagination>
     </div>
     <emptyInfo v-else :emptyMsg="'暂无记录'" ></emptyInfo>
    </div>
  </div>
</template>

<script>
  import emptyInfo from '@/components/empty-info';
  import {nearSixYearsList} from '@/utils/index';
  import {removeTabHandle} from '@/utils/routeTab';
  import projectCom from './components/project-com.vue';
  import Pagination from '@/components/Pagination.vue';
  export default {
    name: "busWitnessTable",
    components: {
      emptyInfo,
      projectCom,
      Pagination
    },
    data(){
      return {
        tableMaxHeight: document.documentElement.clientHeight - 236,
        dataListLoading: false,
        yearsList:[],
        datetimerange:[],
        form: {
          bidYear:new Date().getFullYear(),
          bidSectionName:"", // 标段名称
          bidSectionCode:"", // 标段编号
          tenderProjectCode:"", // 招标项目编号
          tenderProjectName:"", // 所属招标项目
          tendererName:"", // 投标人
          tenderAgencyName:"", // 招标代理结构
          createTimeGE:"", // 登记开始时间
          createTimeLT:"", // 登记结束时间
          tradeId: '', // 交易中心ID
        },
        deleteBtnShow:false,
        selectDeleteList:[],
        businessType:'',
        groupMark:'',
        witnessModlist: [],
        witnessStatuslist: [],
        flownodesListData:[],
        moreSearchItem: false,
        checkList1: '',
        pageSize: 10,//每页条数
        pageIndex: 1,//当前页
        total: 0,//总条数
        tableData: [],
        multipleSelection: [],
        user: '', //角色类型
        formData: {},
        transactionCenterList: [],
        systemType:'GC',
      }

    },

    props:{
      busWitnessTableType: {
            type: String,
            default: ''
        },
        advancedsearchvalue:{
          type:Object,
          default: () => ({})
        }
    },
      watch: {
          busWitnessTableType(newVal){
            this.businessType = newVal;
          }
      },
    filters:{
      ellipsis(text, num) {
        if (text.length > num) {
          return text.substring(0, num) + '...';
        } else {
          return text;
        }
      },

      typeMapperBidNameDesc:function(type){
        switch(type){
          case 'GC':return '标段名称：';break;
          case 'CG':return '包件名称：';break;
          case 'CQ':return '标的名称：';break;
          case 'GT':return '标的名称：';break;
          case 'QT':return '标的名称：';break;
          default:return '标的名称：';break;
        }
      },
      typeMapperBidCodeDesc:function(type){
        switch(type){
          case 'GC':return '标段编号：';break;
          case 'CG':return '包件编号：';break;
          case 'CQ':return '标的编号：';break;
          case 'GT':return '标的编号：';break;
          case 'QT':return '所属项目编号：';break;
          default:return '所属项目编号：';break;
        }
      },
      typeMapperProjectNameDesc:function(type){
        switch(type){
          case 'GC':return '招标项目名称：';break;
          case 'CG':return '采购项目名称：';break;
          case 'CQ':return '项目名称：';break;
          case 'GT':return '项目名称：';break;
          case 'QT':return '项目名称：';break;
          default:return '项目名称：';break;
        }
      },
      typeMapperProjectCodeDesc:function(type){
        switch(type){
          case 'GC':return '招标项目编号：';break;
          case 'CG':return '采购项目编号：';break;
          case 'CQ':return '项目编号：';break;
          case 'GT':return '项目编号：';break;
          case 'QT':return '项目编号：';break;
          default:return '项目编号：';break;
        }
      },
      typeMapperProjectAngle:function(type){
        switch(type){
          case 'GC':return '项目（标段）视角';break;
          case 'CG':return '项目（包件）视角';break;
          case 'CQ':return '项目（标段）视角';break;
          case 'GT':return '项目（标段）视角';break;
          case 'QT':return '项目（标段）视角';break;
          default:return '项目（标段）视角';break;
        }
      },
      typeMapperBidAngle:function(type){
        switch(type){
          case 'GC':return '招标人';break;
          case 'CG':return '采购人';break;
          case 'CQ':return '招标人';break;
          case 'GT':return '招标人';break;
          case 'QT':return '招标人';break;
          default:return '招标人';break;
        }
      },
      typeMapperBidAngle1:function(type){
        switch(type){
          case 'GC':return '招标人：';break;
          case 'CG':return '采购人：';break;
          case 'CQ':return '招标人：';break;
          case 'GT':return '招标人：';break;
          case 'QT':return '招标人：';break;
          default:return '招标人：';break;
        }
      },

    },
    activated(){



      this.businessType = this.busWitnessTableType || window.sessionStorage.getItem('witnessHisBusinessType') ;
      this.getDataList();
      // this.reflash();

      console.log(this.businessType,'我看看业务类型');

    },
    created(){
      this.businessType = this.busWitnessTableType || window.sessionStorage.getItem('witnessHisBusinessType') ;
      this.getDic('jz_dgwitness_witness_mod');
      this.getDic('jz_dgwitness_witness_status');
      this.yearsList = nearSixYearsList(this.form.bidYear)
      this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
    },
    mounted() {

        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if(resizeTag) { //防抖动
                that.ifmove();
                    resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove();
    },
    computed: {

    },

    methods:{

       ifmove() {

         this.tableMaxHeight = ( document.documentElement.clientHeight - 236 ) + 'px';
         this.pageIndex = 1
         if(document.documentElement.clientHeight >900){
           this.pageSize = 16
         }else if(document.documentElement.clientHeight < 770){
           this.pageSize = 8
         }else{
           this.pageSize = 12
         }
          // this.getDataList()

      },
      yearsChange(val){
        this.yearsList = nearSixYearsList(val)
        this.getDataList()
      },
      triggerDeleteBtn(){
        this.deleteBtnShow = !this.deleteBtnShow;
        this.selectDeleteList = [];
      },
      hasSelect(id){
        let index = this.selectDeleteList.indexOf(id);
        return index > -1
      },
      triggerSelectItem(id){
        let index = this.selectDeleteList.indexOf(id);
        if(index > -1){
          this.selectDeleteList.splice(index,1);
        }else{
          this.selectDeleteList.push(id)
        }
      },

      selectAll(flag){
        const that = this;
        this.tableData.forEach(item=>{
          let index = that.selectDeleteList.indexOf(item.id)
          if(flag && index == -1){
            that.selectDeleteList.push(item.id)
          }
          if(!flag){
            that.triggerSelectItem(item.id)
          }
        })
      },

      deleteSelectItem() {
        if (this.selectDeleteList.length > 0) {

          this.$confirm(`确定要删除该数据?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // FIXME 接口对接
            // this.$http.post('/businessFlowWitness/delete',{
            //   idList:this.selectDeleteList
            // }).then(res => {
            //   if (res.data.code == '1') {
            //     this.$message({
            //       type: 'success',
            //       message: res.data.msg
            //     })
            //     this.getDataContent();
            //   } else {
            //     this.$message({
            //       type: 'error',
            //       message: res.data.msg
            //     })
            //   }
            // })
          })
        } else {
          this.$message({
            type: 'error',
            message: "未选择删除项。"
          })
        }
      },

      handleCommand(command) {
        let paramMap = {
          tenderProjectCode:command.item.tenderProjectCode || '',
          bidSectionCode:command.item.bidSectionCode || '',
          projectCode:command.item.projectCode || '',
          applyCode:"",
          idcard:"",
        }
        window.sessionStorage.setItem("witnessHisDetailParamMap",JSON.stringify(paramMap))
        removeTabHandle('businessWitnessHis_detail')
        this.$router.push({
          name: "businessWitnessHis_detail",
          params: { paramMap:paramMap },
          query:{
            businessType:this.businessType,
            angleType:command.angleType,
            purchaserMode:command.item.purchaserMode || ''
          },
        });

      },
      composeValue(type, row) {
        return {
          angleType: type,
          item: row,
        };
      },
      businessTypeFormat(type){
        switch(type){
          case 'GC':return '工程建设';break;
          case 'CG':return '政府采购';break;
          case 'CQ':return '产权交易';break;
          case 'GT':return '国土交易';break;
          case 'QT':return '其他';break;
          default:return '其他';break;
        }
      },
      getDataList(filterObj) { // 获取列表数据
        console.log(filterObj,'看一下列表请求携带数据');
        this.dataListLoading = true;
        let searchKey=filterObj?filterObj.searchKey:''
        this.$http.post('/bidSection/listProjectFlowPaged',{
          'page': this.pageIndex,
          'rows': this.pageSize,
          "searchKey":searchKey || this.$parent.searchKey,
          'filter':filterObj||{busType:this.businessType},
        }).then((res)=>{

          this.dataListLoading = false;
          this.tableData = res.data.data.rows;
          this.total = res.data.data.total;
        })
      },

      getDataLists(filterObj) { // 获取列表数据
        this.dataListLoading = true;
        let searchKey=filterObj?filterObj.searchKey:''
        this.$http.post('/bidSection/listProjectFlowPaged',{
          'page': 1,
          'rows': this.pageSize,
          "searchKey":searchKey||'',
          'filter':filterObj||{busType:this.businessType},
        }).then((res)=>{
          this.dataListLoading = false;
          this.tableData = res.data.data.rows;
          this.total = res.data.data.total;
        })
      },


        // sizeChangeHandle(val) {
        //     this.pageSize = val;
        //     this.pageIndex = 1
        //     this.getDataList()
        // },
        // currentChangeHandle (val) {
        //     this.pageIndex = val
        //     this.getDataList()
        // },
        // 分页器翻页
        paginationChange(obj){

        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||5

        console.log(this.businessType,'看一下类型');

        if (!this.advancedsearchvalue.busType) {
          this.advancedsearchvalue.busType = 'GC';
          this.getDataList(this.advancedsearchvalue);
        } else {
          this.getDataList(this.advancedsearchvalue);
        }
        console.log(this.advancedsearchvalue,'看下高级搜索里的advancedsearchvalue ');
        },
        getDic(type) { // 获取字典

          this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
            if (res.data.code === '1') {
              switch (type) {
                case 'jz_dgwitness_witness_mod':
                  this.witnessModlist = res.data.data;
                  break;
                case 'jz_dgwitness_witness_status':
                  this.witnessStatuslist = res.data.data;
                  break;
              }
            }
          })
        },

        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        //搜索按钮
        seachBtn(){
            this.pageIndex=1;
            this.getDataList()
        },
        reflash() {//刷新按钮
          this.pageIndex = 1;
          this.$refs['form'].resetFields();
          this.datetimerange=[];
          this.form = {
            bidYear:new Date().getFullYear(),
            bidSectionName:"", // 标段名称
            bidSectionCode:"", // 标段编号
            tenderProjectCode:"", // 招标项目编号
            tenderProjectName:"", // 所属招标项目
            tendererName:"", // 投标人
            tenderAgencyName:"", // 招标代理结构
            createTimeGE:"", // 登记开始时间
            createTimeLT:"", // 登记结束时间
          }
          this.yearsList = nearSixYearsList(this.form.bidYear);
          this.getDataList()

        },

        deleteById(item) {
          this.$confirm(`确定要删除该数据?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http.post('/businessFlowWitness/delete', {
              id: item.id
            }).then(res => {
              if (res.data.code == '1') {
                this.$message({
                  type: 'success',
                  message: res.data.msg
                })
                this.getDataList();

              } else {
                this.$message({
                  type: 'error',
                  message: res.data.msg
                })
              }
            })
          })
        },

    },

    destroyed(){
      window.onresize = null;
    },




}
</script>
<style lang="less" scoped>


  .projectCard{

    position: relative;
    overflow: inherit;
    padding: 0;
    margin-bottom: 15px;
    /deep/ .el-card__body{
      padding: 0;
    }
    /deep/ .el-card__header{
      padding: 16px 16px 0px 16px;
    }

    .title {
      width: calc(100% - 10px);
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

  }

    //列表页面
    .main_center{
        .top{
            .seachbtn{
                margin-left:100px;
                display: flex;
            }
        }
    }

</style>
